import { z } from 'zod';

import { ProjectTheme } from '../enums/project.enum';

const TColorOpacityStyleSchema = z.object({
  color: z.string(),
  colorOpacity: z.number(),
});

const TColorStyleSchema = z.object({
  primary: z.string(),
  primaryOpacity: z.number(),
  secondary: z.string(),
  secondaryOpacity: z.number(),
});

const TBackgroundStyleSchema = TColorOpacityStyleSchema.extend({
  image: z.instanceof(File).optional(),
  imageOpacity: z.number().optional(),
});

const TTextStyleSchema = z.object({
  color: z.string(),
  opacity: z.number(),
  fontFamily: z.string(),
  fontStyle: z.string(),
  fontUrl: z.string(),
  fontWeight: z.number(),
});

const TProjectTabSchema = z.object({
  activeTab: z.string(),
  activeTabOpacity: z.number(),
  inactiveTab: z.string(),
  inactiveTabOpacity: z.number(),
});

const TThemeDetailsSchema = z.object({
  bgColorButton: TColorStyleSchema,
  background: TBackgroundStyleSchema,
  container: TColorOpacityStyleSchema,
  headerRow: TColorOpacityStyleSchema,
  referralHeroSection: TBackgroundStyleSchema.merge(TColorOpacityStyleSchema),
});

export const TProjectThemeSchema = z.object({
  modeTheme: z.enum([ProjectTheme.LIGHT, ProjectTheme.DARK]),
  tab: TProjectTabSchema,
  theme: TThemeDetailsSchema,
  components: z.object({
    cornerRadius: z.number(),
  }),
  text: z.object({
    heading: TTextStyleSchema,
    paragraph: TTextStyleSchema,
    subText: TTextStyleSchema,
  }),
  image: z.any(),
});
